// src/lib/themeConfig.js
// ⚠️ Fichier PARTAGÉ entre PageEditor.jsx et PublicPage.jsx

/* ============================================
   THÈMES
   ============================================ */
export const THEMES = [
  { id: 'classic',  name: 'Classique',  bgType: 'solid',    bg: '#0F1B3D', bg2: '#0F1B3D', accent: '#14B8A6', text: '#FFFFFF' },
  { id: 'midnight', name: 'Midnight',   bgType: 'solid',    bg: '#000000', bg2: '#000000', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'teal',     name: 'Teal',       bgType: 'solid',    bg: '#006b5f', bg2: '#006b5f', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'elegant',  name: 'Élégant',    bgType: 'solid',    bg: '#1A1A1A', bg2: '#1A1A1A', accent: '#c9a24a', text: '#FFFFFF' },
  { id: 'light',    name: 'Clair',      bgType: 'solid',    bg: '#F9FAFB', bg2: '#F9FAFB', accent: '#0F1B3D', text: '#0F1B3D' },
  { id: 'slate',    name: 'Slate',      bgType: 'solid',    bg: '#334155', bg2: '#334155', accent: '#38BDF8', text: '#FFFFFF' },
  { id: 'cream',    name: 'Crème',      bgType: 'solid',    bg: '#FAF6EE', bg2: '#FAF6EE', accent: '#B45309', text: '#3F2D1A' },
  { id: 'noir',     name: 'Noir',       bgType: 'solid',    bg: '#0A0A0A', bg2: '#0A0A0A', accent: '#22C55E', text: '#FFFFFF' },
  { id: 'ocean',    name: 'Océan',      bgType: 'gradient', bg: '#0891b2', bg2: '#0F1B3D', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'sunset',   name: 'Sunset',     bgType: 'gradient', bg: '#FF6B6B', bg2: '#FFD93D', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'forest',   name: 'Forêt',      bgType: 'gradient', bg: '#065f46', bg2: '#022c22', accent: '#FCD34D', text: '#FFFFFF' },
  { id: 'rose',     name: 'Rose',       bgType: 'gradient', bg: '#F472B6', bg2: '#EC4899', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'purple',   name: 'Violet',     bgType: 'gradient', bg: '#8B5CF6', bg2: '#4C1D95', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'gold',     name: 'Gold',       bgType: 'gradient', bg: '#c9a24a', bg2: '#78350f', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'candy',    name: 'Candy',      bgType: 'gradient', bg: '#F9A8D4', bg2: '#C4B5FD', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'aurora',   name: 'Aurora',     bgType: 'gradient', bg: '#14B8A6', bg2: '#7C3AED', accent: '#FFFFFF', text: '#FFFFFF' },
  { id: 'crimson',  name: 'Crimson',    bgType: 'gradient', bg: '#7F1D1D', bg2: '#000000', accent: '#F87171', text: '#FFFFFF' },
  { id: 'peach',    name: 'Pêche',      bgType: 'gradient', bg: '#FDBA74', bg2: '#FDE68A', accent: '#7C2D12', text: '#7C2D12' },
  { id: 'sky',      name: 'Ciel',       bgType: 'gradient', bg: '#60A5FA', bg2: '#BFDBFE', accent: '#1E3A8A', text: '#FFFFFF' },
  { id: 'lavender', name: 'Lavande',    bgType: 'gradient', bg: '#DDD6FE', bg2: '#FBCFE8', accent: '#6D28D9', text: '#3B0764' },
  { id: 'mint',     name: 'Menthe',     bgType: 'gradient', bg: '#A7F3D0', bg2: '#5EEAD4', accent: '#065F46', text: '#064E3B' },
  { id: 'sand',     name: 'Sable',      bgType: 'gradient', bg: '#E7D8B1', bg2: '#C9A24A', accent: '#4A2E10', text: '#3F2D1A' },
]

/* ============================================
   POLICES
   ============================================ */
export const FONTS = [
  { id: 'inter',    name: 'Inter',         family: "'Inter', sans-serif" },
  { id: 'jakarta',  name: 'Plus Jakarta',  family: "'Plus Jakarta Sans', sans-serif" },
  { id: 'poppins',  name: 'Poppins',       family: "'Poppins', sans-serif" },
  { id: 'georgia',  name: 'Georgia',       family: 'Georgia, serif' },
  { id: 'playfair', name: 'Playfair',      family: "'Playfair Display', serif" },
  { id: 'space',    name: 'Space Grotesk', family: "'Space Grotesk', sans-serif" },
  { id: 'mono',     name: 'Monospace',     family: "'Courier New', monospace" },
  { id: 'raleway',  name: 'Raleway',       family: "'Raleway', sans-serif" },
]

/* ============================================
   FORMES DE BOUTONS
   ============================================ */
export const BUTTON_SHAPES = [
  { id: 'rounded', name: 'Arrondi', radius: '16px' },
  { id: 'pill',    name: 'Pilule',  radius: '999px' },
  { id: 'square',  name: 'Carré',   radius: '8px' },
  { id: 'sharp',   name: 'Net',     radius: '0px' },
  { id: 'blob',    name: 'Blob',    radius: '16px 4px 16px 4px' },
]

/* ============================================
   FORMES D'AVATAR
   ============================================ */
export const AVATAR_SHAPES = {
  circle:  'rounded-full',
  rounded: 'rounded-2xl',
  square:  'rounded-none',
  hexagon: 'rounded-lg',
}

/* ============================================
   TAILLES D'AVATAR
   ============================================ */
export const AVATAR_SIZES = {
  xs: 'w-12 h-12',
  sm: 'w-16 h-16',
  md: 'w-20 h-20',
  lg: 'w-28 h-28',
}

/* ============================================
   TAILLES DE BOUTONS
   ============================================ */
export const BUTTON_SIZES = {
  sm: 'py-2 px-3 text-xs',
  md: 'py-3 px-4 text-sm',
  lg: 'py-4 px-5 text-base',
}

/* ============================================
   OMBRES DE CARTES
   ============================================ */
export const CARD_SHADOWS = {
  none: '',
  sm: '0 1px 3px rgba(0,0,0,0.1)',
  md: '0 4px 12px rgba(0,0,0,0.15)',
  lg: '0 10px 40px rgba(0,0,0,0.2)',
}

/* ============================================
   RAYONS DE BORDURE
   ============================================ */
export const CARD_RADII = {
  none: '0',
  sm: '8px',
  md: '16px',
  lg: '24px',
}

/* ============================================
   SETTINGS PAR DÉFAUT
   ============================================ */
export const DEFAULT_SETTINGS = {
  theme: 'classic',
  customColors: false,
  customBg: '#0F1B3D',
  customBg2: '#14B8A6',
  customText: '#FFFFFF',
  customAccent: '#14B8A6',
  font: 'inter',
  buttonShape: 'rounded',
  buttonStyle: 'solid',
  buttonSize: 'md',
  buttonHover: 'scale',
  avatarShape: 'circle',
  avatarSize: 'md',
  textAlign: 'center',
  shadow: 'md',
  borderRadius: 'md',
  opacity: 100,
  pattern: 'none',
}

/* ============================================
   HELPERS
   ============================================ */
export function getTheme(settings) {
  if (settings?.customColors) {
    return {
      bgType: 'gradient',
      bg: settings.customBg || '#0F1B3D',
      bg2: settings.customBg2 || settings.customBg || '#0F1B3D',
      accent: settings.customAccent || '#14B8A6',
      text: settings.customText || '#FFFFFF',
    }
  }
  return THEMES.find(t => t.id === settings?.theme) || THEMES[0]
}

export function getBgStyle(theme, opacity = 100) {
  const style = theme.bgType === 'gradient'
    ? { background: `linear-gradient(135deg, ${theme.bg}, ${theme.bg2})` }
    : { background: theme.bg }
  if (opacity !== 100) style.opacity = opacity / 100
  return style
}

export function getPatternStyle(pattern, color) {
  if (pattern === 'dots')     return { backgroundImage: `radial-gradient(${color} 1.5px, transparent 1.5px)`, backgroundSize: '18px 18px' }
  if (pattern === 'grid')     return { backgroundImage: `linear-gradient(${color} 1px, transparent 1px), linear-gradient(90deg, ${color} 1px, transparent 1px)`, backgroundSize: '24px 24px' }
  if (pattern === 'diagonal') return { backgroundImage: `repeating-linear-gradient(45deg, ${color} 0, ${color} 1px, transparent 1px, transparent 14px)` }
  return {}
}

export function getButtonStyle(theme, buttonStyleId = 'solid') {
  return {
    solid:   { background: theme.accent, color: theme.text },
    outline: { border: `2px solid ${theme.accent}`, color: theme.accent, background: 'transparent' },
    glass:   { background: 'rgba(255,255,255,0.15)', color: theme.text, backdropFilter: 'blur(10px)' },
  }[buttonStyleId] || { background: theme.accent, color: theme.text }
}

export function getHoverClass(hoverId = 'scale') {
  return {
    none: '',
    scale: 'hover:scale-[1.02]',
    lift: 'hover:-translate-y-1 hover:shadow-lg',
    glow: 'hover:shadow-[0_0_20px_rgba(255,255,255,0.35)]',
    pulse: 'hover:animate-pulse',
  }[hoverId] || 'hover:scale-[1.02]'
}
// Résout le thème final (custom prioritaire sur prédéfini)
export function resolveTheme(settings) {
  if (settings?.customColors) {
    return {
      id: 'custom',
      name: 'Personnalisé',
      bg: settings.customBg || '#0F1B3D',
      accent: settings.customAccent || '#14B8A6',
      text: settings.customText || '#FFFFFF',
    }
  }
  return getTheme(settings)
}